import { generateHooks } from "../generators/generator.hooks";
import { GENERATOR_PARAMS } from "./exportFile.constants";
export var usePaged = generateHooks(GENERATOR_PARAMS).usePaged;
